import { Permission, Role, UserView } from 'api/user';

export function can(user?: UserView, ...permissions: Permission[]) {
  return user?.permissions?.length
    ? permissions.some((p) => user.permissions?.includes(p))
    : false;
}

const PROVIDER_ROLES: Role[] = [Role.COACH, Role.THERAPIST, Role.AI_COACH];

/**
 * Whether a role belongs to someone who delivers care rather than receives it.
 *
 * The distinction is not the same as "can edit provider fields", which is a
 * property of the page being rendered. This is a property of the person: a
 * provider has no member record behind them, so anything sourced from one —
 * insurance above all — has nothing to show and never will.
 */
export const isProviderRole = (role?: string | null): boolean =>
  PROVIDER_ROLES.includes(role as Role);
